import { useEffect, useState } from "react";

import useAxios from "@hooks/use-axios";

const DEFAULT_LIMIT = 20;
const EMPTY_STATS = { total_invoices: 0, outstanding: 0, paid_to_date: 0 };

// Brand-scoped twin of the ops publisher-invoices hook: same payload, but the
// account in the path is what limits it to publishers under this brand.
const useBrandPublisherInvoices = (brandId, publisherId) => {
    const { axiosInstance, loading } = useAxios({ base: "brand", initialLoader: true });
    const [invoices, setInvoices] = useState([]);
    const [pagination, setPagination] = useState({ total: 0, page: 1, limit: DEFAULT_LIMIT });
    const [stats, setStats] = useState(EMPTY_STATS);

    const fetchInvoices = async (page = 1, limit = DEFAULT_LIMIT) => {
        if (!brandId || !publisherId) return;
        try {
            const res = await axiosInstance.get(`v1/accounts/${brandId}/affiliates/${publisherId}/invoices`, {
                params: { page, limit }
            });
            const result = res.data || res;
            const list = result.items || result.data || result.results || [];
            setInvoices(list);
            setPagination({
                total: result.total ?? list.length,
                page : result.page ?? page,
                limit: result.limit ?? limit
            });
            setStats(result.stats || EMPTY_STATS);
        } catch {
            setInvoices([]);
            setPagination({ total: 0, page, limit });
            setStats(EMPTY_STATS);
        }
    };

    useEffect(() => {
        fetchInvoices(1, DEFAULT_LIMIT);
    }, [brandId, publisherId]); // eslint-disable-line react-hooks/exhaustive-deps

    const handlePageChange = (limit, page) => fetchInvoices(page, limit);
    const handlePerRowsChange = (limit) => fetchInvoices(1, limit);

    return { invoices, loading, stats, pagination, handlePageChange, handlePerRowsChange };
};

export default useBrandPublisherInvoices;
